var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-task-info-wrapper",
    {
      attrs: { state: _vm.state },
      on: {
        file: function ($event) {
          return _vm.sendFile($event)
        },
        edit: function ($event) {
          return _vm.edit()
        },
      },
    },
    [
      _c("app-chat-messages", {
        attrs: { value: _vm.messages },
        on: {
          "fetch-more": function ($event) {
            return _vm.fetchMoreMessages()
          },
        },
      }),
      _c("app-message-input", {
        on: {
          send: function ($event) {
            return _vm.sendMessage()
          },
          file: function ($event) {
            return _vm.sendFile($event)
          },
        },
        model: {
          value: _vm.message,
          callback: function ($$v) {
            _vm.message = $$v
          },
          expression: "message",
        },
      }),
      _vm.state.openedFolder
        ? _c(
            "w-modal",
            {
              attrs: { "escape-close": "" },
              model: {
                value: _vm.editModal,
                callback: function ($$v) {
                  _vm.editModal = $$v
                },
                expression: "editModal",
              },
            },
            [
              _c("app-task-edit", {
                attrs: {
                  folder: _vm.state.openedFolder.Folder,
                  state: _vm.state,
                },
                on: {
                  close: function ($event) {
                    _vm.editModal = false
                  },
                  saved: function ($event) {
                    return _vm.refresh()
                  },
                  remove: function ($event) {
                    return _vm.remove()
                  },
                },
                model: {
                  value: _vm.editTask,
                  callback: function ($$v) {
                    _vm.editTask = $$v
                  },
                  expression: "editTask",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }